export default __webpack_public_path__ + "images/UQ.d887da9.png";